import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss'],
})
export class ChartLegendComponent {
  @Input() legend: { name: string; inactive?: boolean }[];
  @Input() colors: string[];

  @Output() itemToggled = new EventEmitter<void>();

  toggleItem(item) {
    item.inactive = !item.inactive;
    this.itemToggled.emit();
  }
}
